import {
  AssignmentCandidateLocation,
  RSAssignmentCandidate,
  RSContractorAssignmentCandidate,
} from '@/api/apis/resources';

const includesIgnoreCase = (value: string, substring: string) => value.toLowerCase().includes(substring.toLowerCase());

export const searchEmployeeSurgeons = (searchTerm: string, surgeons?: RSAssignmentCandidate[]) => {
  return surgeons?.filter((s) => includesIgnoreCase(s.employeeFullName, searchTerm)) ?? [];
};

export const searchContractorSurgeons = (searchTerm: string, surgeons?: RSContractorAssignmentCandidate[]) => {
  return (
    surgeons?.filter((s) => {
      return (
        includesIgnoreCase(s.employeeFullName, searchTerm) ||
        includesIgnoreCase(s.affiliation?.entityName ?? '', searchTerm)
      );
    }) ?? []
  );
};

export const formatHomeLocation = (homeLocation?: AssignmentCandidateLocation) => {
  const { city, postalCode, country } = homeLocation ?? {};
  return homeLocation ? `${city}, ${postalCode}, ${country}` : '';
};
